import { render, staticRenderFns } from "./popover-button.vue?vue&type=template&id=06880a90"
import script from "./popover-button.vue?vue&type=script&lang=js"
export * from "./popover-button.vue?vue&type=script&lang=js"
import style0 from "./popover-button.vue?vue&type=style&index=0&id=06880a90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports